// Indicate the direction of scrollability; where more content is available.
// Use bitwise flags for op convenience.
export enum XScrollDirections {
  None = 0,
  Left = 1,
  Right = 2,
  Both = 4,
}

export enum YScrollDirections {
  None = 0,
  Up = 1,
  Down = 2,
  Both = 4,
}
